import { Field, ErrorMessage, useFormikContext } from "formik";

export const FilterFromToDateField = ({
  label = "Date Range",
  name = "",
  required = false,
  className = "",
  fromValue,
  toValue,
  type = "date",
}) => {
  const { errors, touched } = useFormikContext();

  const fromName = `${name}.from`;
  const toName = `${name}.to`;

  const hasError =
    (touched?.[name]?.from && errors?.[name]?.from) ||
    (touched?.[name]?.to && errors?.[name]?.to);

  return (
    <div className={`w-full ${className}`}>
      <div className="flex flex-col gap-1 w-full">
        <label
          className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${
            hasError ? "text-errorColor" : "text-darkText"
          }`}
        >
          {label}
        </label>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-2">
          <div>
            <label>From</label>
            <Field name={fromName}>
              {({ field, meta }) => (
                <div className="flex flex-col gap-1">
                  <input
                    {...field}
                    type={type}
                    required={required}
                    className={`px-3 py-2 w-full rounded-lg border-[1px]
                    text-fs_14 text-darkText placeholder-greyText focus:outline-none
                    ${
                      meta.touched && meta.error
                        ? "border-errorColor"
                        : "border-greyText"
                    }`}
                    value={fromValue}
                  />
                  <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
                    <ErrorMessage name={fromName} />
                  </label>
                </div>
              )}
            </Field>
          </div>
          <div>
            <label>To</label>
            <Field name={toName}>
              {({ field, meta }) => (
                <div className="flex flex-col gap-1">
                  <input
                    {...field}
                    type={type}
                    required={required}
                    className={`px-3 py-2 w-full rounded-lg border-[1px]
                    text-fs_14 text-darkText placeholder-greyText focus:outline-none
                    ${
                      meta.touched && meta.error
                        ? "border-errorColor"
                        : "border-greyText"
                    }`}
                    value={toValue}
                  />
                  <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
                    <ErrorMessage name={toName} />
                  </label>
                </div>
              )}
            </Field>
          </div>
        </div>
      </div>
    </div>
  );
};
